import { Table, TableContainer, TableHead, TableRow, makeStyles, createStyles, Theme, Button } from "@material-ui/core"
import Paper from '@material-ui/core/Paper'
import { ContractsTableBody, StyledTableCell } from "../../ContractsTableBody/ContractsTableBody";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        btn: {
            display: "block",
            margin: "20px auto",
            "&:hover": {
                border: "1px solid #3062A0"
            }
        }
    }),
)

type UserContractsPropsType = {
    contracts?: any[]
    viewMoreBtnIsVisible: boolean
    setPageNumber: (pageNumber: number) => void
    pageNumber: number
}

export default function UserContracts(props: UserContractsPropsType) {
    const classes = useStyles()

    const {pageNumber, setPageNumber, viewMoreBtnIsVisible} = props
    if (props.contracts) {
        return (
            <>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Case ID</StyledTableCell>
                                <StyledTableCell align="center">Date Created</StyledTableCell>
                                <StyledTableCell align="center">Status</StyledTableCell>
                                <StyledTableCell align="center">Amount Due</StyledTableCell>
                                <StyledTableCell align="center">Days Until Rate Increase</StyledTableCell>
                                <StyledTableCell align="center">Paid Off</StyledTableCell>
                                <StyledTableCell align="center">Client</StyledTableCell>
                                <StyledTableCell align="center">Attorney</StyledTableCell>
                                <StyledTableCell align="center">Law Firm</StyledTableCell>
                            </TableRow>
                        </TableHead>

                        <ContractsTableBody data={props.contracts} hiddenRows={['currentContractRiskRatePercent']} />

                    </Table>
                </TableContainer>
                {viewMoreBtnIsVisible &&
                    <Button color="primary" variant="outlined" className={classes.btn}
                            onClick={() => {
                                setPageNumber(pageNumber + 1)
                            }}>
                        View more
                    </Button>
                }
            </>
        )
    }
    else {
        return (
            <h2 style={{ textAlign: "center" }}>Cases not found</h2>
        )
    }
}
